import Container from '@/components/Container/Container'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import { Validator } from 'vee-validate'
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      username: null,
      password: null
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      isLoading: 'authLoading',
      error: 'authError'
    })
  },
  components: {
    Container,
    FontAwesomeIcon
  },
  methods: {
    authenticate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const { username, password } = this
          this.$store.dispatch('authenticate', { username, password }).then(() => {
            this.$router.push('/')
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/script.js